// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProductType } from './product-type';
import { ProductTypeConfig } from './product-type-config';
import { ProgramRequirement } from './program-requirement';
import { ProgramReview } from './program-review';
import { ProximityUser } from './proximity-user';
import { ReviewGuideline } from './review-guideline';
import { ReviewGuidelineKind } from './review-guideline-kind';
import { ReviewResolution } from './review-resolution';
import { ReviewSeverity } from './review-severity';
import { ReviewGuidelineKindEnum } from './enums';
import { ReviewResolutionEnum } from './enums';
import { ReviewSeverityEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramReviewFinding extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK carriedFromFinding */
  carriedFromFindingId?: string;
  /** String */
  evidenceJson?: string;
  /** String(250) */
  findingKey!: string;
  /** String */
  message!: string;
  /** Guid FK productTypeConfig */
  productTypeConfigId?: string;
  /** Guid FK productType */
  productTypeId?: string;
  /** Guid FK programRequirement */
  programRequirementId?: string;
  /** Guid FK programReview */
  programReviewId!: string;
  /** String */
  resolutionReason?: string;
  /** Guid FK resolvedByUser */
  resolvedByUserId?: string;
  /** DateTimeOffset */
  resolvedTs?: Date;
  /** Guid FK reviewGuideline */
  reviewGuidelineId?: string;
  /** Enum FK reviewGuidelineKind */
  reviewGuidelineKindId!: ReviewGuidelineKindEnum;
  /** Enum FK reviewResolution */
  reviewResolutionId!: ReviewResolutionEnum;
  /** Enum FK reviewSeverity */
  reviewSeverityId!: ReviewSeverityEnum;
  /** Binary */
  rowVersion!: any;
  /** FK carriedFromFindingId */
  carriedFromFinding!: ProgramReviewFinding;
  /** FK productTypeId */
  productType!: ProductType;
  /** FK productTypeConfigId */
  productTypeConfig!: ProductTypeConfig;
  /** FK programRequirementId */
  programRequirement!: ProgramRequirement;
  /** FK programReviewId */
  programReview!: ProgramReview;
  /** FK resolvedByUserId */
  resolvedByUser!: ProximityUser;
  /** FK reviewGuidelineId */
  reviewGuideline!: ReviewGuideline;
  /** FK reviewGuidelineKindId */
  reviewGuidelineKind!: ReviewGuidelineKind;
  /** FK reviewResolutionId */
  reviewResolution!: ReviewResolution;
  /** FK reviewSeverityId */
  reviewSeverity!: ReviewSeverity;
}

